module.exports = __webpack_public_path__ + "img/gzjt1.a600b8f5.jpg";